class LineStateStatusType {
  None() {
    return 0;
  }
  Active() {
    return 1;
  }
  Expired() {
    return 2;
  }
  Extended() {
    return 3;
  }
  Canceled() {
    return 4;
  }
  SeparateFromPackage() {
    return 5;
  }
  Archived() {
    return 6;
  }
  RejectActivation() {
    return 7;
  }
}
export default new LineStateStatusType();
